import Vue from "vue";
import Vuex from "vuex";
import VuexEasyFirestore from "vuex-easy-firestore";
import modules from "./modules";
import Firebase from "@/firebase";
import router from "./router";

Vue.use(Vuex);

const easyFirestore = VuexEasyFirestore(
  [
    modules.articlesModule,
    modules.settingsModule,
    modules.tagsModule,
    modules.statsModule,
    modules.reportersModule
  ],
  {
    logging: true,
    FirebaseDependency: Firebase
  }
);

export default new Vuex.Store({
  plugins: [easyFirestore],
  state: {},
  mutations: {},
  actions: {
    init({ dispatch }) {
      dispatch("articles/openDBChannel").catch(console.error);
      dispatch("settings/openDBChannel").catch(console.error);
      dispatch("tags/openDBChannel").catch(console.error);
      dispatch("stats/openDBChannel").catch(console.error);
      dispatch("reporters/openDBChannel").catch(console.error);
    },
    logout() {
      Firebase.auth()
        .signOut()
        .then(() => {
          localStorage.setItem("authenticated", false);
          router.push("/login");
        });
    },
    upsertArticle({ dispatch }, arg) {
      console.log(arg);
      return dispatch("articles/set", arg);
    }
  },
  getters: {
    articles: state => {
      return Object.entries(state.articles.articles).map(v => v[1]);
    },
    reporters: state => {
      return Object.entries(state.reporters.reporters).map(v => v[1]);
    }
  }
});
